module.exports = __webpack_public_path__ + "img/turbo_on.524c61ac.png";